import angular from 'angular'
import dataCollection from './dataCollection'
import declarationGeneration from './declarationGeneration'
import reportTaskTracking from './reportTaskTracking'
import reportQuery from './reportQuery'
import declareParam from './declareParam'

export default angular
  .module('declaration.vatDeclarationSurcharges', [
    dataCollection,
    declarationGeneration,
    reportTaskTracking,
    reportQuery,
    declareParam,
  ])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      $stateProvider.state('declaration.vatDeclarationSurcharges', {
        abstract: true,
        url: '/vatDeclarationSurcharges',
        template: '<div ui-view></div>',
        title: '增值税申报及附加(一般)',
      })
    },
  ]).name



// WEBPACK FOOTER //
// ./src/app/declaration/vatDeclarationSurcharges/index.js